import { CONSENT_FLAG, tabNames } from '@va/constants';
import { setActiveTab } from '@va/dashboard/actions/ui';
import { PageHeader, TitleAndContextMenu } from '@va/dashboard/shared/ui-layout';
import { useTranslate } from '@va/localization';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ConsentSettings from './ConsentSettings';

export function ConsentPage() {
  const translate = useTranslate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveTab(tabNames.consent));
  }, [dispatch]);

  return (
    <>
      <PageHeader
        title={<TitleAndContextMenu title={translate('wix.consent.title')} tooltipTransKey={'tooltipTab.consent'} />}
        hideDatePicker
      />
      <div className='px-10 sm:px-5'>
        <ConsentSettings priorConsent={CONSENT_FLAG.YOUTUBE} />
      </div>
    </>
  );
}
